import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './AdminLogin.css';

const AdminLogin = ({ onLogin, onBack }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Default staff password - in production, this should be stored securely
  const STAFF_PASSWORD = 'Urvika@1925';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));

    if (password === STAFF_PASSWORD) {
      onLogin();
    } else {
      setError('❌ Incorrect password. Please try again.');
      setPassword('');
    }
    
    setIsLoading(false);
  };

  return (
    <div className="admin-login">
      <Header title="Staff Access" />
      <div className="login-container">
        <div className="login-header">
          <button className="back-btn" onClick={onBack}>
            ← Back
          </button>
          <h1>🔐 Staff Access</h1>
          <p>Enter staff password to access admin panel</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="password">🔑 Staff Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter staff password"
              required
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? '🔐 Verifying...' : '🔐 Access Admin Panel'}
          </button>
        </form>

        <div className="login-info">
          <h3>📋 Staff Instructions:</h3>
          <ul>
            <li>Only authorized staff can access this panel</li>
            <li>Contact management for password access</li>
            <li>Keep password secure and confidential</li>
            <li>Log out when finished</li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminLogin; 